import type React from 'react';
import { useMarqueeAnimation } from '../chat/hooks/useMarqueeAnimation';

interface MarqueeScrollTextProps {
  children: React.ReactNode;
  animationKey: string;
  containerClassName?: string;
  textClassName?: string;
}

const MarqueeScrollText = ({
  children,
  animationKey,
  containerClassName = '',
  textClassName = '',
}: MarqueeScrollTextProps) => {
  const { shouldAnimate, textRef, containerRef } = useMarqueeAnimation(animationKey);

  return (
    <div ref={containerRef} className={containerClassName}>
      {shouldAnimate ? (
        <div className="header-title-marquee flex w-max items-center">
          <div className="flex shrink-0 items-center">
            <p ref={textRef} className={textClassName}>
              {children}
            </p>
            <span className="w-[16px] shrink-0" aria-hidden="true" />
          </div>
          <div className="flex shrink-0 items-center" aria-hidden="true">
            <p className={textClassName}>{children}</p>
            <span className="w-[16px] shrink-0" aria-hidden="true" />
          </div>
        </div>
      ) : (
        <p ref={textRef} className={textClassName}>
          {children}
        </p>
      )}
    </div>
  );
};

export default MarqueeScrollText;
